import React from 'react'
import PrimaryButton from '../../components/Buttons/PrimaryButton';
import { useHistory, useParams } from 'react-router';
import TextInput from '../../components/Inputs/TextInput';
import ReactSelect from '../../components/Inputs/ReactSelect';
import SecondaryButton from '../../components/Buttons/SecondaryButton';
import { COLORS, SCAN_TYPES } from '../../config';
import useScans from '../../store/scans/scansContext';
import UploadIcon from '../../components/Icons/outline/UploadIcon';
import SecondaryButtonAccent from '../../components/Buttons/SecondaryButtonAccent';
import AddScanModal from './AddScanModal';
import { MoonLoader } from 'react-spinners';
import MultipleScansCreatedModal from './MultipleScansCreatedModal';

function AddScan() {

  const { patientId } = useParams();
  
  const history = useHistory();
  const { addScan } = useScans();

  const [formError, setFormError] = React.useState({
    field: '',
    msg: ''
  });

  
  const [newScan, _setNewScan] = React.useState({
    type: null,
    description: null,
  });
  
  const [ scanFiles, setScanFiles ] = React.useState(null);
  const [ showAddScan, setShowAddScan ] = React.useState(false);
  const [ isScanAdd, setIsScanAdd ] = React.useState(false);
  const [showMultipleScansModal, setShowMultipleScansModal] = React.useState(false)

  const setNewScan = (newVal) => _setNewScan({...newScan, ...newVal});

  const scanTypeOptions = [];
  const scanTypes = Object.values(SCAN_TYPES);
  
  if (!scanTypeOptions.length) scanTypes.forEach(type => {
    scanTypeOptions.push({
      value: type,
      label: type
    })
  });
  
  const handleCreate = async () => {
    let element;
    if (newScan.description === '' || newScan.description === null) {
      element = document.getElementById('description');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      
      return setFormError({
        field: 'description',
        msg: "Please enter a Description."
      });
    }
    if (newScan.type === '' || newScan.type === null ) {
      element = document.getElementById('type');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'type',
        msg: "Please enter scan type."
      });
    }
    if (!scanFiles) {
      element = document.getElementById('scanFiles');
      element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
      return setFormError({
        field: 'scanFiles',
        msg: "Please include a file to upload."
      });
    }
    setIsScanAdd(true)
    const response = await addScan(patientId, scanFiles, newScan).then(res => {
      if (Array.isArray(res)) {
        setShowMultipleScansModal(true)
        setIsScanAdd(false)
        return;
      }
      setIsScanAdd(false)
      history.goBack();
    }).catch(e => {
      setIsScanAdd(false)
    });

  }

  const handleFileUpload = (files) => { 
    setScanFiles(files);
    setShowAddScan(false)
  } 
  
  return (
    <div className="flex flex-col">
      <AddScanModal scanType={newScan.type} showAddScan={showAddScan} closeModal={setShowAddScan} handleFileUpload={handleFileUpload}/>
      <MultipleScansCreatedModal show={showMultipleScansModal} setShow={setShowMultipleScansModal} onClickConfirm={() => history.goBack()} />
      {isScanAdd && (
          <div className='inset-2/4 flex absolute w-full ml-10' >
            <div className='rounded-lg shadow-xl flex justify-around min-h-170 pr-20 pl-20 items-center' style={{border: '1px solid lightgray', background: 'white'}}>
              <MoonLoader color={COLORS.colorPrimary}/>
             </div> 
          </div>
        )}
      <div className="bg-white rounded shadow py-12 px-10">
        <div className='flex justify-between items-center'>
          <h1 className="mb-10 text-2xl text-secondary">Scan information</h1>
        </div>
        <div className='grid grid-cols-4 gap-y-4 '>
          <TextInput id='description' label='Description*' inputClass='col-span-3' value={newScan.description} onChange={(e) => setNewScan({description: e.target.value})}/>
          {formError.field === 'description' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <ReactSelect id='type' label='Scan Type*' options={scanTypeOptions} value={newScan.type} inputClass='col-span-3' onChange={(e) => setNewScan({ type: e.value })} /> 
          {formError.field === 'type' && 
          <span className="text-red-400 text-sm col-span-4">{formError.msg}</span>
          }
          <label id='scanFiles' className={`font-semibold text-secondary my-auto mt-4`}>Scan Files*</label>
          {!isScanAdd && <SecondaryButtonAccent disabled={newScan.type ? false : true} className='mt-4' onClick={() => setShowAddScan(true)} text="Upload files" icon={<UploadIcon stroke={newScan.type ? COLORS.colorPrimary : 'lightgray'}/>} />}
          {formError.field === 'scanFiles' &&
          <span className="text-red-400 text-sm">{formError.msg}</span>
          }
          {
            scanFiles && Array.from(scanFiles).length && <div className='mt-2 ml-3'>{Array.from(scanFiles).length} files attached</div>
          }
        </div>
      </div>
      <div className='flex flex-row-reverse mt-8 mb-4'>
        <PrimaryButton text='Create' disabled={isScanAdd} onClick={handleCreate} className='min-w-180 ml-4'/>
        <SecondaryButton text='Cancel' disabled={isScanAdd} onClick={() => history.goBack()} className='min-w-180'/>
      </div>
    </div>
  )
}

export default AddScan;
